import { gql } from "@apollo/client"

export const DeleteDomain = gql`
mutation DeleteDomain($deleteDomainId: ID!) {
  deleteDomain(id: $deleteDomainId) {
    status
  }
}
`